<template>
  <!-- 敏感词统计 -->
  <div class="senWord-statistics">
    <!-- 搜索栏 -->
    <div class="staff-chat-supervise-search">
      <div class="serach-left">
        <el-date-picker
          v-model="searchSelectTime"
          size="mini"
          type="daterange"
          :editable="false"
          value-format="yyyy-MM-dd"
          range-separator="~"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          @change="selectTime"
          :picker-options="pickerOptions"
          :clearable="false"
          style="width: 240px; margin-right: 10px"
        >
        </el-date-picker>
        <el-input  size="mini" suffix-icon="el-icon-search"  style="width: 190px;margin-right: 10px" v-model="formInline.wordName" placeholder="敏感词" @blur="onInputBlur" @clear="onInputBlur" clearable>
        </el-input>
        <el-input  size="mini" suffix-icon="el-icon-search"  style="width: 190px;margin-right: 10px" v-model="formInline.userName" placeholder="姓名" @blur="onInputBlur" @clear="onInputBlur" clearable>
        </el-input>
      </div>
      <div class="serach-right" v-if="mgctjdcdj">
        <el-button 
          type="primary"
          size="mini"
          @click="handleExport"
          >导出</el-button
        >
      </div>
    </div>
    <!-- 表格 -->
    <el-row :gutter="20">
      <el-col>
        <el-table
          size="small"
          :data="tableData"
          fit
          @row-click="handleclick"
          highlight-current-row
          :header-cell-style="{ background: '#F9F9F9' }"
          height="calc(100vh - 238px)"
          empty-text="暂无敏感词的违规情况"
          ref="cusChatTable"
          style="font-size: 13px"
        >
          <el-table-column
            align="center"
            prop="wordName"
            label="敏感词"
            min-width="150"
          ></el-table-column>
          <el-table-column
            align="center"
            label="归属分类"
            min-width="150"
          >
            <template slot-scope="scope">
              <span>{{(scope.row.wordTypeName && scope.row.wordTypeName != null)?scope.row.wordTypeName:'-' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="hitCount"
            align="center"
            label="出现次数"
            min-width="80"
          ></el-table-column>
          <el-table-column
            prop="userCount"
            align="center"
            label="涉及员工数"
            min-width="80"
          ></el-table-column>
          <el-table-column
            label="涉及员工明细"
            min-width="250"
            align="center"
            :show-overflow-tooltip="false"
          >
            <template slot-scope="scope">
              <div class="tag-wrap">
                <span v-for="(item,index) in scope.row.users" :key="item.userId">
                  <span>{{ item.userName }}</span><span v-if="index != scope.row.users.length-1">、</span>
                </span>
                <span v-if="scope.row.showMoreFlag">
                  <span>...</span>
                </span>
                <span class="more-users" @click="toDetail(scope.row)"> 明细</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <Pagination
      :childMsg="pageparm"
      :pageSizes="pageSizes"
      @callBack="callBack"
    ></Pagination>
    <senDetail ref="senDetail" />
  </div>
</template>

<script>
import {statistical} from "@/api/senWord/senWord.js"
import senDetail from "./components/senDetail.vue"
export default {
  name: 'SenWordStatistics',
  components: {
    senDetail
  },
  data() {
    return {
      mgctjdcdj: false,         // 导出权限按钮
      searchSelectTime: [],     // 搜索时间
      // 发送请求列表参数
      formInline: {
        current: 1,
        size: 20,
        userName: '',
        wordName: '',
        startTime: '',
        endTime: ''
      },
      // 表格数据
      tableData: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      // 日期只能选择一个月范围内
      choiceDate: '',
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate = minDate.getTime()
          if (maxDate) {
            this.choiceDate = ''
          }
        },
        disabledDate: (time) => {
          if (this.choiceDate && this.choiceDate != null) {
            const one = 30 * 24 * 3600 * 1000
            const minTime = this.choiceDate - one
            const maxTime = this.choiceDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      }
    }
  },
  watch: {
    btnAuthority: {
      handler(newVal,oldVal) {
        if(newVal.length > 0) {
          newVal.forEach(item => {
            if(item.pname == '敏感词统计') {
              let senBtnAuthority = item.cfunBu
              if(senBtnAuthority.indexOf('mgctjdcdj') != -1) {
                // 可绑定、解绑
                this.mgctjdcdj = true
              }else {
                this.mgctjdcdj = false
              }
            }
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    btnAuthority() {
      return this.$store.state.tagsView.roleAuthrority
    }
  },
  created() {
    let that = this;
    that.getNowTime();
    that.formInline.current = that.pageparm.currentPage;
    that.formInline.size = that.pageparm.pageSize;
    that.getDataList(that.formInline);
    // let data = {
    //     "total": 4,
    //     "result": [
    //         {
    //             "corpId": "wpHiy3CAAAequJYEEUoNdnna0cbjqvQQ",
    //             "wordId": "164",
    //             "wordName": "测试数据1",
    //             "wordTypeId": "1545240467980029952",
    //             "wordTypeName": "张金子测试呀1",
    //             "users": [
    //                 {
    //                     "wordId": "164",
    //                     "userId": "woHiy3CAAAm2mTBeV5fEKVetoCuA",
    //                     "userName": "小金"
    //                 },
    //                 {
    //                     "wordId": "169",
    //                     "userId": "woHi3CAAm2mTBjV5fEKzVetoClyA",
    //                     "userName": "测试账号小金"
    //                 },
    //                 {
    //                     "wordId": "168",
    //                     "userId": "woHi3CAAAm2mTBjeV5fEKVtoCulyA",
    //                     "userName": "张晓金测试账号小金~1350~"
    //                 },
    //                 {
    //                     "wordId": "167",
    //                     "userId": "woHy3CAAAm2TBeV5fEKzVetCulyA",
    //                     "userName": "张晓金"
    //                 },
    //                 {
    //                     "wordId": "166",
    //                     "userId": "woHiyCAAAm2mTeV5fEKzVetoCulA",
    //                     "userName": "张晓金测试账号小金~1350~"
    //                 }
    //             ],
    //             "hitCount": 2,
    //             "userCount": 1
    //         },
    //         {
    //             "corpId": "wpHiy3CAAAeJYEEUoNdnna0cbjqvQQ",
    //             "wordId": "165",
    //             "wordName": "在被封的边缘疯狂试探",
    //             "wordTypeId": "1545240467980029952",
    //             "wordTypeName": "张金子测试呀1",
    //             "users": [
    //                 {
    //                     "wordId": "165",
    //                     "userId": "woHiy3CAAAm2mTBjeV5fEKzVetoCulyA",
    //                     "userName": "张晓金测试账号小金~1350~"
    //                 }
    //             ],
    //             "hitCount": 1,
    //             "userCount": 1
    //         },
    //         {
    //             "corpId": "wpHiy3CAAAequJYEEUoNdnna0cbjqvQQ",
    //             "wordId": "166",
    //             "wordName": "我只是用来测试",
    //             "wordTypeId": "1545240467980029952",
    //             "wordTypeName": "张金子测试呀1",
    //             "users": [
    //                 {
    //                     "wordId": "166",
    //                     "userId": "woHiy3CAAAm2mTBjeV5fEKzVetoCulyA",
    //                     "userName": "张晓金测试账号小金~1350~"
    //                 }
    //             ],
    //             "hitCount": 7,
    //             "userCount": 1
    //         },
    //         {
    //             "corpId": "wpHiy3CAAAequJYEEUoNdnna0cbjqvQQ",
    //             "wordId": "170",
    //             "wordName": "闲得无聊",
    //             "wordTypeId": "1545240467980029952",
    //             "wordTypeName": "张金子测试呀1",
    //             "users": [
    //                 {
    //                     "wordId": "170",
    //                     "userId": "woHiy3CAAAm2mTBjeV5fEKzVetoCulyA",
    //                     "userName": "张晓金测试账号小金~1350~"
    //                 }
    //             ],
    //             "hitCount": 1,
    //             "userCount": 1
    //         }
    //     ]
    // }
    // that.pageparm.total = data.total;
    // that.tableData = data.result;
    // that.tableData.forEach(item => {
    //   item.showMoreFlag = false
    //   if(item.users.length > 4) {
    //     item.users = item.users.slice(0,4)
    //     item.showMoreFlag = true
    //   }
    // });
  },
  methods: {
    // 查看明细
    toDetail(row) {
      this.$refs.senDetail.show(row,this.searchSelectTime);
    },
    // 导出
    handleExport() {
      let hour =" 00:00:00"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
      let hour2 =" 23:59:59"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
      let obj = JSON.parse(JSON.stringify(this.formInline))
      obj.startTime = obj.startTime + hour
      obj.endTime = obj.endTime + hour2
      this.download('/sensitive/record/statistical/export', `敏感词统计表_${new Date().getTime()}.xlsx`,{
        ...obj
      },localStorage.getItem("Authorization"))
    },
    //处理默认选中当前日期
    getNowTime() {
      let that = this;
      let now = new Date();
      let year = now.getFullYear(); //得到年份
      let month = now.getMonth(); //得到月份
      let date = now.getDate(); //得到日期
      // let hour =" 00:00:00"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
      // let hour2 =" 23:59:59"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      let startDefaultDate = `${year}-${month}-${date}`;
      let endDefaultDate = `${year}-${month}-${date}`;
      let arr = [startDefaultDate,endDefaultDate];
      that.formInline.startTime = startDefaultDate;
      that.formInline.endTime = endDefaultDate;
      that.searchSelectTime = JSON.parse(JSON.stringify(arr));
    },
    // 时间处理
    selectTime(dataTime) {
      if(dataTime != null) {
        this.formInline.startTime = dataTime[0];
        this.formInline.endTime = dataTime[1];
      }else {
         this.getNowTime()
      }
      this.formInline.current = 1;
      this.getDataList(this.formInline);
    },
    // 姓名/部门搜索框的blur事件
    onInputBlur(){
      this.formInline.current = 1
      this.getDataList(this.formInline)
    },
    // 表格单击事件
    handleclick(row, column, event) {
      // let params = {
      //   wordId: row.wordId,
      //   startTime: this.formInline.startTime,
      //   endTime: this.formInline.endTime
      // }
      // this.$refs.SenWordChatRecord.show(params);  // 打开聊天记录 2022.8.25弃用

    },
    // 分页回调函数
    callBack(parm) {
      this.formInline.current = parm.currentPage;
      this.formInline.size = parm.pageSize;
      this.getDataList(this.formInline);
    },

    // 获取列表数据
    getDataList(params) {
      let that = this;
      let hour =" 00:00:00"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
      let hour2 =" 23:59:59"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
      let obj = JSON.parse(JSON.stringify(params))
      obj.startTime = obj.startTime + hour
      obj.endTime = obj.endTime + hour2
      statistical(obj,localStorage.getItem("Authorization")).then(res => {
        if(res.error.code == 200){
          that.pageparm.total = res.data.total;
          that.tableData =  res.data.result;
          that.tableData.forEach(item => {
            item.showMoreFlag = false
            if(item.users.length > 4) {
              item.users = item.users.slice(0,3)
              item.showMoreFlag = true
            }
          });
        }
      }).catch(err => {
        console.log(err,'errr')
      })
    },
    
    // 获取对应员工敏感词记录
  } 
}
</script>

<style lang="scss">
.senWord-statistics {
  .staff-chat-supervise-search {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    .serach-left {
      display: flex;
    }
    .serach-right {
      flex: 1;
      display: flex;
      justify-content: flex-end;
    }
  }
  .tag-wrap {
    overflow:hidden; 
    text-overflow:ellipsis;
    display:-webkit-box; 
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2; 
    .el-tag {
      max-width: 6em;
      overflow: hidden;
      white-space: nowrap;
      text-overflow:ellipsis;
    }
    .el-tag--plain{
      border-color: #606266;
      color: #606266;
    }
    .more-users {
      color: #409EFF;
      cursor: pointer;
      margin-left: 3px;
    }
  }
  
}

</style>